import { defineStore } from 'pinia'

export const useStatusStore = defineStore('status', {
	state: () => ({
		pending: {
			user: false,
			redirect: false,
			// The FwF flow router's own flag, not `redirect`: it must also keep the funnel
			// container unmounted, and reusing `redirect` would do that to every other
			// consumer of it too.
			fwfRouter: false,
		},
		ready: {
			network: false,
			i18n: false,
			absmartly: false,
			coreFeatures: false,
		},
		absmartlyRequired: true,
	}),

	getters: {
		resourceIsPending: (state) => (name) => {
			return state.pending[name]
		},

		networkResourceIsReady(state) {
			return state.ready.network
		},

		coreFeaturesResourceIsReady(state) {
			return state.ready.coreFeatures
		},

		requiredResourcesAreReady(state) {
			const resources = ['i18n', 'network', 'coreFeatures']
			if (state.absmartlyRequired) {
				resources.push('absmartly')
			}
			return resources.every((name) => state.ready[name])
		},

		getResourceIsReady: (state) => (name) => {
			return state.ready[name]
		},
	},

	actions: {
		setResourcePending(name) {
			this.pending[name] = true
		},

		unsetResourcePending(name) {
			this.pending[name] = false
		},

		setResourceReadiness(name) {
			this.ready[name] = true
		},

		setAbsmartlyRequired(value) {
			this.absmartlyRequired = value
		},
	},
})
